import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';

const BatchSummaryChart = ({ batchData }) => {
  if (!batchData || batchData.length === 0) {
    return <p>No batch data available to display the chart.</p>;
  }

  // Prepare data for the chart
  const labels = batchData.map(batch => {
    const datePart = batch.batch_date.split(' ')[0]; // Get YYYY-MM-DD
    return `${batch.batch_id} (${datePart})`;
  });

  const normalData = batchData.map(batch => batch.totalNormal);
  const spamData = batchData.map(batch => batch.totalSpam);
  const unknownData = batchData.map(batch => batch.totalUnknown);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Normal',
        data: normalData,
        backgroundColor: '#34A853', // Green
        borderColor: '#34A853',
        borderWidth: 1,
      },
      {
        label: 'Spam',
        data: spamData,
        backgroundColor: '#EA4335', // Red
        borderColor: '#EA4335',
        borderWidth: 1,
      },
      {
        label: 'Unknown',
        data: unknownData,
        backgroundColor: '#4285F4', // Blue
        borderColor: '#4285F4',
        borderWidth: 1,
      },
    ],
  };
  const isSingleBatch = batchData.length === 1;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Caller ID Status - Summary',
        font: {
          size: 16,
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: 'Batch ID (Date)',
        },
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          minRotation: 0,
        }
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Count',
        },
        beginAtZero: true,
        ticks: {
          precision: 0, // Ensure whole numbers for counts
        },
      },
    },
    barThickness: isSingleBatch ? 80 : undefined,
  };

  return (
    <div style={{ height: '400px', width: '100%' }}> {/* Adjust height as needed */}
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default BatchSummaryChart;